import './rustytaco/style';
import FormStructure from './rustytaco/form_structure';

export default FormStructure;